var modules_3f9ccc85 = {"appBanner":"_iwmchb","storesBanner":"_1n00nxo","contactsBanner":"_1f34x6"};
import "../../../assets/USRNCzQp.css";

export { modules_3f9ccc85 as default };
//# sourceMappingURL=MainContent.module.less.js.map
